import { Injectable } from '@angular/core';

import { SportModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { NumberDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { HorseRaceSortingDirection, WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';

import { OptionType } from '../../../dropdown/models';
import { HorsesFixtureMarketHelper } from '../../../horse-racing-shared/services/horses-fixture-market-helper.service';

@Injectable({ providedIn: 'root' })
export class BaseRaceWinMarketService {
    constructor(
        protected horsesFixtureMarketHelper: HorsesFixtureMarketHelper,
        public sitecore: Sitecore,
    ) {}

    getSortDirection(fixture: WinGameFixture, allPricesLocked: boolean, allPricesSP: boolean) {
        const winMarketSuspended = this.horsesFixtureMarketHelper.isWinMarketFixedOddsLocked(fixture);

        if (allPricesLocked || allPricesSP || winMarketSuspended) {
            return HorseRaceSortingDirection.CardNumber;
        }

        return HorseRaceSortingDirection.Odds;
    }

    getActiveSortOption(sortBy: HorseRaceSortingDirection) {
        if (sortBy === HorseRaceSortingDirection.CardNumber) {
            return {
                id: sortBy,
                name: this.sitecore.horseRacing.raceDetails.CardNumberSorting,
                type: OptionType.Regular,
            };
        }

        return {
            id: sortBy,
            name: this.sitecore.horseRacing.raceDetails.OddsSorting,
            type: OptionType.Regular,
        };
    }

    getExpandedState(model: SportModel | WinGameParticipant, expandedParticipant: NumberDictionary<boolean>): boolean {
        return expandedParticipant[model.id] || false;
    }
}
